// hooks/useLeagueAccessGuard.js
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "../UserContext";
import { useLeague } from "../utils/LeagueContext";

const useLeagueAccessGuard = () => {
  const { leagueId: urlLeagueId } = useParams();
  const { user } = useUser();
  const { selectedLeague, leagueId, setSelectedLeagueAndId } = useLeague();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = async () => {
      if (!user) {
        navigate("/createaccount");
        return;
      }

      // If no league is selected, and one is in the URL, try setting it
      if (!leagueId && urlLeagueId) {
        await setSelectedLeagueAndId(urlLeagueId);
      }

      // If league is now loaded, check access
      const memberIds = selectedLeague?.members?.map((m) => m.userId);
      const isCommissioner = selectedLeague?.leagueCommissioner === user._id;

      if (selectedLeague && !memberIds?.includes(user._id) && !isCommissioner) {
        console.warn("User is not authorized for this league");
        // ✅ Clear the league and ID
        setSelectedLeagueAndId(null);
        localStorage.removeItem("leagueId");
        // ✅ Navigate away
        navigate("/unauthorized");
      }
    };

    if (user && urlLeagueId) checkAccess();
  }, [user, urlLeagueId, leagueId, selectedLeague]);
};

export default useLeagueAccessGuard;


